import styled from '@emotion/styled';
import { Button, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import HexagonIcon from '@mui/icons-material/Hexagon';

export const MainContent = styled.div`
display: flex;
justify-content: center;
align-items: flex-start;
`;

export const WrapperCategory = styled('div')(() => `
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: flex-start;
gap: 20px;
`);

export const WrapperBook = styled(Paper)(() => `
display: flex;
flex-direction: column;
gap: 20px;
width: 100%;
padding: 6px;
text-align: left;
font-size: 12px;
@media (min-width: 600px){
padding: 10px 16px;
font-size: 16px;
}
`);


export const DescriptionBook = styled('div')(() => `
display: flex;
flex-direction: column;
flex-wrap: wrap;
justify-content: flex-start;
align-items: flex-start;
gap: 6px;
width: 100%;
max-width: 500px;
text-align: left;
`);

export const TitleBook = styled('h2')(({ theme }) => `
color: ${theme.palette.primary.main};
align-self: center;
`);


export const WrapperNotification = styled(Paper)(() => `
width: 100%;
padding: 6px;
text-align: left;
font-size: 12px;
@media (min-width: 600px){
padding: 10px 16px;
font-size: 16px;
}
`);

export const NewInfo = styled('h3')(({ theme }) => `
font-weight: 700;
font-size: 14px;
@media (min-width: 600px) {
   font-size: 16px;
}
`);

export const WrapperImg = styled('div')(() => `
   max-width: 100%;
   @media (min-width: 600px) {
      max-width: 70%;
}
`);


export const WrapperSteps = styled('ul')(() => `
margin-bottom: 10px;
`);

export const ItemOption = styled('li')(() => `
display: flex;
justify-content: flex-start;
align-items: center;
gap: 4px;
`);

export const IconHexagon = styled(HexagonIcon)(({ theme }) => `
width: 16px;
height: 16px;
color: ${theme.palette.primary.main};
`);

export const WrapperCategoryDescription = styled('div')(() => `
display: flex;
justify-content: flex-start;
align-items: center;
gap: 20px;
`);


export const ButtonCategory = styled(Button)(() => `
flex-shrink: 0; 
width: 70px;
height: 70px;
border-radius: 6px;
font-size: 24px;
`);

export const Dscription = styled('p')(() => `
text-align: start;
font-size: 12px;
@media (min-width: 600px) {
   font-size: 16px;
}
`);

export const NameCategory = styled('span')(() => `
font-weight: 700;
text-transform: capitalize;
`);

export const ButtonKangourou = styled(Link)(({ theme }) => `
width: 70px;
height:70px;
flex-shrink: 0;
border-radius: 6px;
border: 2px solid ${theme.palette.cadet.main};
box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
transition: box-shadow 250ms cubic-bezier(0.4,0,0.2,1) 0ms;  
&:hover{
     box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
     background-color: transparent;
  }
`);

export const ButtonAbout = styled(Button)(({ theme }) => `
width: 70px;
height:70px;
flex-shrink: 0;
border-radius: 50%;
`);

